import { ref, onMounted } from "vue"
import CreditCardService from "@/core/JCB/service/CreditCardService"

export default function useCreditCardComposable(getOnMount = true) {

    /**
     * @type {import("vue").Ref<Array.<import("@/types/CreditCardModel.d").CreditCardModel>>}
     */
    const creditCardList = ref([])

    const apiGetCardList = function () {
        return new Promise((resolve, reject) => {
            CreditCardService.apiGetCardList().subscribe({
                next: (data) => {
                    creditCardList.value = data
                    resolve(data)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    }

    /**
     *
     * @param {import("@/core/JCB/model/CreditCardModel").CreditCardModelBuilder} modelBuilder
     */
    const apiDeleteJCBCard = function (modelBuilder) {
        return new Promise((resolve, reject) => {
            CreditCardService.apiDeleteCard(modelBuilder).subscribe({
                next: (data) => {
                    resolve(data)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    }

    if (getOnMount) {
        onMounted(apiGetCardList)
    }

    return {
        creditCardList,
        apiGetCardList,
        apiDeleteJCBCard
    }

}
